import { Theme } from "../constants";

export default {
    irsSwitchLabelCustomStyle: {
        width: "28px",
        height: "14px",
    },
    irsSwitchButtonCustomStyle: {
        top: "1px",
        width: "10px",
        height: "10px",
    },
    IRSViewMainContainer: {
        display: "flex",
        flexDirection: "column",
    },
    IRSViewHeaderRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "30px",
    },
    selectedFormInfo: {
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
        gap: "20px"
    },
    IRSGridContainer: { 
        display: 'grid', 
        gridTemplateColumns: 'repeat(60, 1fr)', 
        // gridAutoRows: '100px', 
        gridGap: '5px',
        border: "2px solid #000000",
        padding: "5px"
    },
    boxInputFieldLabel: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    IRSViewSwitchDiv: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    irsViewSwitch:{
        marginRight: "8px",
        display: "flex",
    },
    irsViewText: {
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    IRSViewFooterRow: {
        marginTop: "20px",
    },
    previewFormText: {
        fontWeight: 700,
        lineHeight: "19px",
        marginRight: "10px",
    },
    labelStyle: {
        width: "100%",
        marginBottom: "0px",
    },
    IRSPayerRecipientButtons: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    addEditIntermediaryButtonsDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    requiredStarLabel: {
        color: Theme.ERROR_TEXT,
    },
    helpTextIconStyle: {
        cursor: "pointer",
    }
}